
define('text!templates_dir/pwstrength/meter.hbs',[],function () { return '<div class="pw-strength">\n    <div class="pw-strength-description small"></div>\n    <div class="pw-strength-meter-container">\n        <div class="pw-strength-meter"></div>\n    </div>\n</div>\n\n';});

